import { Model } from '@tsim/model';
import { isObject } from 'lodash';

export class BaseEntity extends Model {
  static isType(type: unknown): type is typeof BaseEntity {
    return isObject(type) && 'getFields' in type;
  }
}
